export const GET_LIST_DIMENSIONS_WATCHER =
  "app/WidgetListDimensions/GET_LIST_DIMENSIONS_WATCHER"
export const GET_LIST_DIMENSIONS_SUCCESS =
  "app/WidgetListDimensions/GET_LIST_DIMENSIONS_SUCCESS"
export const GET_LIST_DIMENSIONS_FAILED =
  "app/WidgetListDimensions/GET_LIST_DIMENSIONS_FAILED"
